import { useState } from 'react';
import { CssBaseline, Box, Chip, Grid } from '@mui/material';
import StyledDataGrid from './StyledDataGrid';
import colors from '../../assets/colors';

const tooltip = {
  type: 'string',
  sortable: false,
  renderCell: (params) => (
    <Chip
      label={`${params.value && params.value}`}
      sx={{ backgroundColor: colors.agroweGreen, color: colors.white }}
    />
  ),
  cellClassName: '',
};

const attachment = {
  type: 'string',
  sortable: false,
  renderCell: (params) => {
    if (params.row.attachmentFileList.length > 0) {
      const chips = params.row.attachmentFileList.map((a, index) => (
        <Chip
          key={`${a.date + a.id}`}
          label={`${a.date}`}
          sx={{
            backgroundColor: colors.agroweGreen,
            color: colors.white,
            mb: 1,
            mt: index === 0 ? 1 : 0,
          }}
        />
      ));
      return (
        <Grid container direction="column">
          {chips}
        </Grid>
      );
    } else return <></>;
  },
  cellClassName: '',
};

export default function DataGrid(props) {
  const [pageSize, setPageSize] = useState(25);
  let columns = [];
  let rows = [];

  props.rowData?.forEach((element) => {
    rows.push({ ...element });
  });
  props.columnData?.forEach((element) => {
    if (element.type === 'tooltip') columns.push({ ...element, ...tooltip });
    if (element.type === 'attachment')
      columns.push({ ...element, ...attachment });
    else columns.push({ ...element });
  });

  return (
    <Box sx={{ height: props.height ?? 650 }}>
      <CssBaseline />
      <StyledDataGrid
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 25, 50]}
        {...props}
      />
    </Box>
  );
}
